import { render, staticRenderFns } from "./CompImageText.vue?vue&type=template&id=77908c02"
import script from "./CompImageText.vue?vue&type=script&lang=js"
export * from "./CompImageText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports